import { DiscountCommissionIcon } from "assets/icons";
import cn from "classnames";
import { t } from "i18next";

import { OrderProductProps } from "../OrderModal.types";

import styles from "../OrderModal.module.scss";

export const OrderProduct = ({ item, className }: OrderProductProps) => {
  return (
    <div
      className={cn(styles.orderModal__productsBlock__product, className)}
      key={`productVariant-item-${item.barcodeId}`}
    >
      <div className={styles.orderModal__productsBlock__imageThumb}>
        <img
          src={item.barcode?.productVariant?.image?.url ?? undefined}
          className={styles.orderModal__productsBlock__image}
        />
      </div>
      <div className={styles.orderModal__productsBlock__info}>
        {item.packSlotTitle && (
          <div className={styles.orderModal__productsBlock__packSlotTitle}>
            {item.packSlotTitle}
          </div>
        )}
        <div className={styles.orderModal__productsBlock__title}>
          {item.barcode?.productVariant?.name ?? ""}
        </div>

        <div className={styles.orderModal__productsBlock__points}>
          <div className={styles.orderModal__productsBlock__point}>
            {t("Size")}:{" "}
            {item.barcode?.sizeAttributeValue?.value ?? t("NO SIZES")}
          </div>
          <span>·</span>
          <div className={styles.orderModal__productsBlock__point}>
            {t("Color")}:{" "}
            {item.barcode?.productVariant?.colorAttributeValue?.value
              ? t(item.barcode.productVariant.colorAttributeValue.value)
              : "—"}
          </div>
          <span>·</span>
          <div className={styles.orderModal__productsBlock__point}>
            {t("Qty")}: {item.quantity}
          </div>
        </div>

        {!item.packGroupId && (
          <div className={styles.orderModal__productsBlock__price}>
            <div>
              {item.discountedPricePerItem.toLocaleString("en-US")} FCFA
            </div>
            {item.discountAmount > 0 && (
              <div className={styles.orderModal__productsBlock__priceOld}>
                {item.price.toLocaleString("en-US")} FCFA
              </div>
            )}
          </div>
        )}
        {!item.packGroupId && item.margin > 0 && (
          <div className={styles.orderModal__productsBlock__margin}>
            <DiscountCommissionIcon width={16} height={16} fill="#FB3973" />
            <div className={styles.orderModal__productsBlock__marginPrice}>
              {item.margin.toLocaleString("en-US")} FCFA
            </div>
            <div className={styles.orderModal__productsBlock__marginTitle}>
              {t("Margin")}
            </div>
          </div>
        )}

        {!item.packGroupId && item.commission > 0 && (
          <div className={styles.orderModal__productsBlock__commission}>
            <DiscountCommissionIcon width={16} height={16} />
            <div className={styles.orderModal__productsBlock__commissionPrice}>
              {item.commission.toLocaleString("en-US")} FCFA
            </div>
            <div className={styles.orderModal__productsBlock__commissionTitle}>
              {t("Commission")}
            </div>
          </div>
        )}

        {/* On a personal order the price above is already reduced by this
            amount and the commission is 0, so without the line the lower price
            has no explanation. */}
        {!item.packGroupId && item.personalDiscountAmount > 0 && (
          <div className={styles.orderModal__productsBlock__commission}>
            <DiscountCommissionIcon width={16} height={16} />
            <div className={styles.orderModal__productsBlock__commissionPrice}>
              {item.personalDiscountAmount.toLocaleString("en-US")} FCFA
            </div>
            <div className={styles.orderModal__productsBlock__commissionTitle}>
              {t("Personal discount")}
            </div>
          </div>
        )}

        {/* Same reason as the line above: the price shown is already reduced by
            this, so without the line the lower price has no explanation. */}
        {!item.packGroupId && item.suggestionDiscountAmount > 0 && (
          <div className={styles.orderModal__productsBlock__commission}>
            <DiscountCommissionIcon width={16} height={16} />
            <div className={styles.orderModal__productsBlock__commissionPrice}>
              {item.suggestionDiscountAmount.toLocaleString("en-US")} FCFA
            </div>
            <div className={styles.orderModal__productsBlock__commissionTitle}>
              {t("Cross-sell discount")}
            </div>
          </div>
        )}

        {!!item.quantityOfItemsToUnpack && (
          <div className={styles.orderModal__productsBlock__productInfoLabel}>
            {`${item.quantityOfItemsToUnpack} ${t("items")} ${t("waiting to unpack")}`}
          </div>
        )}

        {item.isUnavailable && (
          <div className={styles.orderModal__productsBlock__productInfoLabel}>
            {item.quantityOfUnavailable > 0
              ? `${item.quantityOfUnavailable} ${item.quantityOfUnavailable > 1 ? t("items") : t("item")} ${t("marked as unavailable")}`
              : t("Product marked as unavailable")}
          </div>
        )}
      </div>
    </div>
  );
};
